import { getCookie, TOKEN_COOKIE } from "../utils/cookies";

interface DecodedToken {
  exp?: number;
  [key: string]: unknown;
}

const decodeToken = (token: string): DecodedToken | null => {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
        .join(""),
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
};

export const getTokenExpiration = (token: string): number | null => {
  const decoded = decodeToken(token);
  if (!decoded?.exp) return null;
  return decoded.exp * 1000;
};

export const isTokenExpired = (token: string): boolean => {
  const expMs = getTokenExpiration(token);
  if (expMs === null) return false;
  return Date.now() >= expMs;
};

export const useToken = (): string => {
  const token = getCookie(TOKEN_COOKIE);
  if (!token || isTokenExpired(token)) {
    throw new Error("Authentication token not found or expired.");
  }
  return token;
};
